import React from 'react'

import Dropdown from "./ReactDropdown";

export default class DropdownMetNotMet extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		var v = 
	    {
		      mode: 'list', 
	    	  label: 'Select a Gender' , 
	    	  defaultValue: '#',
			  emptyValue: '#',
	   		  containerClassName: '',
		}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		let defaultValue = props.defaultValue ;

		if ( this.props.defaultValue == null )
		{
			defaultValue = 	'#' ;
		}

    	// Create a state item here
		this.state = { dirty: false ,currentValue: defaultValue, items: null };
	}

	UNSAFE_componentWillMount()
	{
		// Fetch the list of types to populste the dropdown
		this.getdata () ;
	}
	
	getdata( )
	{
		var items = [
		{
			id: '#',
			desc: 'Please select a response'
		},			  
		{
			id: 'Y',
			desc: 'Met'
		},
		{
			id: 'N',
			desc: 'Not Met'
		}
		];
				
		this.setState ( { items : items } ) ;
	}
	
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0 || param == -1 || param == '#')
				{
					if ( this.state.items == null )
					{
						return true ;
					}
					else
					{
						if ( this.state.items.length > 0)
						{
							return false ;						
						}
						else
						{
							return true ;
						}
					}
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}


	handleChange(e) 
	{
		var targetName = e.target.name ;
		var val = e.target.value ;
		var index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		var offset = 0 ;
		
		if ( this.props.mode == 'filter')
		{
			var offset = -1 ;
		}

		if ( index >= 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.callback != null )
		{
			this.props.callback ( itemtext ) ;		
		}
		
	}

    getValue()
    {
    	return this.state.currentValue ;
    }

    returnOption ( row )
	{
		return React.createElement ( 'option', {key: this.keyCount++, name: row.id, value: row.id} , row.desc ) ;
	}

    optionList ()
    {
		return this.state.items.map(element =>
		{
			return this.returnOption ( element ) ;
		});
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }
  
    render() 
    {
		if ( this.props.readOnly != 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
    }
};


